import React from "react";

const FormContext = React.createContext({
    formState: {},
    updater: () => null,
});
FormContext.displayName = 'FormContext';

export default FormContext;
